import { setThemeColor, ThemeShades } from '@bamboohr/fabric';

export function setupTheme() {
  function setupThemeHandler() {
    const theme = document.body.getAttribute('ba-theme');

    if (typeof theme === 'string' && theme.startsWith('{')) {
      const parsedTheme: ThemeShades = JSON.parse(theme) as ThemeShades;
      setThemeColor(parsedTheme);
    }
  }

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', setupThemeHandler);
    return;
  }

  setupThemeHandler();
}
